<template>
  <div class="keyboard">
    <div class="keyboardLine">
      <div v-for="(element, index) in lettersToDisplay.slice(0,10)" :key="index">
        <div class="letter lightSilverTheme verySmallRoundAngles smallShadow clickable"
             :class="[{redLetter: element.status == 'red'}, {blueLetter: element.status == 'blue'}]"
             @click="selectLetter(element.letter)"
             :key="proposedLetters.length">
          {{ element.letter }}
        </div>
      </div>
    </div>

    <div class="keyboardLine">
      <div v-for="(element, index) in lettersToDisplay.slice(10,20)" :key="index">
        <div class="letter lightSilverTheme verySmallRoundAngles smallShadow clickable"
             :class="[{redLetter: element.status == 'red'}, {blueLetter: element.status == 'blue'}]"
             @click="selectLetter(element.letter)"
             :key="proposedLetters.length">
          {{ element.letter }}
        </div>
      </div>
    </div>

    <div class="keyboardLine">
      <div v-for="(element, index) in lettersToDisplay.slice(20)" :key="index">
        <div class="letter lightSilverTheme verySmallRoundAngles smallShadow clickable"
             :class="[{redLetter: element.status == 'red'}, {blueLetter: element.status == 'blue'}]"
             @click="selectLetter(element.letter)"
             :key="proposedLetters.length">
          {{ element.letter }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "keyboard26",

  props: {
    proposedLetters: Array,
  },

  created() {
    for(let i=0; i< 26; i++) {
      this.lettersToDisplay.push( {status: 'fresh', letter: String.fromCharCode(i + 65)});
    }

    this.azertyfy();
  },

  watch: {
    'proposedLetters': function() {
      this.proposedLetters.forEach((element) => {
        this.lettersToDisplay.forEach((letter, index, array) => {
          if(element.letter == letter.letter) {
            array[index].status = element.status
          }
        })
      })
    }
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
  },

  methods: {
    selectLetter(letter) {
      if(letter !== ' ') {
        this.$emit('letterSuggested', letter)
      }
    },

    proposed(letter) {
      this.proposedLetters.forEach(element => {
        if (element.letter == letter) {
          return true
        }
      })
      return false
    },
    azertyfy() {
      this.lettersToDisplay[0].letter = 'A'; // A
      this.lettersToDisplay[1].letter = 'Z'; // B
      this.lettersToDisplay[2].letter = 'E'; // C
      this.lettersToDisplay[3].letter = 'R'; // D
      this.lettersToDisplay[4].letter = 'T'; // E
      this.lettersToDisplay[5].letter = 'Y'; // F
      this.lettersToDisplay[6].letter = 'U'; // G
      this.lettersToDisplay[7].letter = 'I'; // H
      this.lettersToDisplay[8].letter = 'O'; // I
      this.lettersToDisplay[9].letter = 'P'; // J
      this.lettersToDisplay[10].letter = 'Q'; // K
      this.lettersToDisplay[11].letter = 'S'; // L
      this.lettersToDisplay[12].letter = 'D'; // M
      this.lettersToDisplay[13].letter = 'F'; // N
      this.lettersToDisplay[14].letter = 'G'; // O
      this.lettersToDisplay[15].letter = 'H'; // P
      this.lettersToDisplay[16].letter = 'J'; // Q
      this.lettersToDisplay[17].letter = 'K'; // R
      this.lettersToDisplay[18].letter = 'L'; // S
      this.lettersToDisplay[19].letter = 'M'; // T
      this.lettersToDisplay[20].letter = 'W'; // U
      this.lettersToDisplay[21].letter = 'X'; // V
      this.lettersToDisplay[22].letter = 'C'; // W
      this.lettersToDisplay[23].letter = 'V'; // X
      this.lettersToDisplay[24].letter = 'B'; // Y
      this.lettersToDisplay[25].letter = 'N'; // Z

      this.lettersToDisplay.forEach((element, index, array) => {
        array.splice(index, 1, element)
      })
    }
  },

    data() {
      return {
        lettersToDisplay: []
      }
    }
}
</script>

<style scoped>
  .keyboard {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .keyboardLine {
    display: flex;
    flex-direction: row;
  }

  .letter {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.25vw;
    width: 2vw;
    height: 2vw;
  }

  .inactive {
    visibility: hidden;
  }
  .redLetter {
    background-color: #d44337;
    cursor: default;
  }

  .blueLetter {
    background-color: #50fd86;
    cursor: default;
    color: #020202;
  }

  @media screen and (max-device-width: 767px) {
    .keyboard {
      width: 80%;
    }

    .letter {
      margin: 0.9vw;
      width: 8vw;
      height: 8vw;
      font-weight: bold;
    }
  }
</style>